module.exports = __webpack_public_path__ + "static/media/ivsz.3717dff6.png";